import { combineReducers } from "redux";
import environmentReducer from "./Environment";
import countrySelectorReducer from "./CountrySelector";
import premierPageFrameReducer from "./PremierPageFrame";
import premierPropositionReducer from "./PremierProposition";
import premierPricingTableReducer from "./PremierPricingTable";
import premierSelectorOptionsReducer from "./PremierSelectorOptions";
import modalReducer from "./Modal";

const reducers = combineReducers({
  Environment: environmentReducer,
  CountrySelector: countrySelectorReducer,
  PremierPageFrame: premierPageFrameReducer,
  PremierProposition: premierPropositionReducer,
  PremierPricingTable: premierPricingTableReducer,
  PremierSelectorOptions: premierSelectorOptionsReducer,
  Modal: modalReducer,
});

export default reducers;
